
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/charts-toolbar-print-export-trigger",
      function () {
        return require("private-next-pages/x/api/charts/charts-toolbar-print-export-trigger.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/charts-toolbar-print-export-trigger"])
      });
    }
  